export enum OPERATORI {
  INIZIA_CON = 1,
  FINISCE_CON = 2,
  CONTIENE = 3,
  MAGGIORE = 4,
  MINORE = 5,
  UGUALE = 6,
  MAGGIORE_UGUALE = 7,
  MINORE_UGUALE = 8,
  VICINO = 9,
  DIVERSO=10,
  NOTLIKE = 11,
  REGEXP=15,
  IN=16,
  UGUALE_DATA=17,
  MAGGIORE_UGUALE_DATA=18,
  MINORE_UGUALE_DATA=19,
  MAGGIORE_DATA=20,
  MINORE_DATA=21
}
